import { StyledInvestmentCarving } from './InvestmentCarving.style';
import { WhiteSection } from 'components/base/layout-components';
import Header from '../ResourceAllocationOverview/Header';
import CategoriesWidget from './CategoriesWidget';
import SettingsButton from './settings/SettingsButton';
import useAvailability from '../ResourceAllocationOverview/useAvailability';
import EmptyState, {
  EMPTY_STATE_MODULES
} from '../ResourceAllocationOverview/EmptyState/EmptyState';
import useAmplitudeVisit from 'common/hooks/tracking/useAmplitudeVisit';
import { TRACKING } from 'common/constants/constants';
import { InvestmentCarvingFiltersContext } from '../state/filters/contexts';
import FiltersProvider from '../state/filters/FiltersProvider';
import ProjectsFiltersBar from '../state/filters/components/ProjectsFiltersBar';

const InvestmentCarving = () => {
  useAmplitudeVisit({ page: TRACKING.PAGES.INVESTMENT_PROFILE });
  const { isEmptyState } = useAvailability();

  if (isEmptyState)
    return <EmptyState module={EMPTY_STATE_MODULES.INVESTMENT_CARVING} />;

  return (
    <FiltersProvider Context={InvestmentCarvingFiltersContext}>
      <StyledInvestmentCarving>
        <ProjectsFiltersBar Context={InvestmentCarvingFiltersContext} />
        <WhiteSection>
          <Header
            Context={InvestmentCarvingFiltersContext}
            SettingsButton={SettingsButton}
            withPeriodPicker={false}
          />
        </WhiteSection>
        <CategoriesWidget />
      </StyledInvestmentCarving>
    </FiltersProvider>
  );
};

export default InvestmentCarving;
